export const state = {
    faqCategories: [],
}